export default __webpack_public_path__ + "static/media/google.9cdd1946.png";